import { RemoteTogglePartnerRequest } from 'data/usecases/partners';
import { makeApiUrlPartnerRequests } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteTogglePartnerRequest = (): RemoteTogglePartnerRequest => {
  return new RemoteTogglePartnerRequest(
    makeApiUrlPartnerRequests(),
    makeAxiosHttpClient(),
  );
};
